import React from 'react';
import Button from '@material-ui/core/Button';
import ConfirmationDialog from 'commons/components/ConfirmationDialog';

// Material

// icons

const BtnRelease = ({
  controls, actions, psId, status,
}) => {
  const handleClose = () => {
    actions.changeControls('confirmationReleaseDialog', false);
  };

  const handleSubmit = () => {
    actions.releasePaymentStatus(status, psId);
  };

  return (
    <>
      <ConfirmationDialog open={controls.confirmationReleaseDialog} onClose={handleClose} onConfirm={handleSubmit} content="¿Desea liberar el estado de pago?" />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={() => {
          actions.changeControls('confirmationReleaseDialog', true);
        }}
      >
        LIBERAR ESTADO DE PAGO
      </Button>
    </>
  );
};

export default BtnRelease;
